/* AURA Idle Loader 4.0 */
window.AuraIdle = window.AuraIdle || (() => {
  const queue = [];
  let running = false;

  const requestIdle = window.requestIdleCallback || ((cb) => setTimeout(() => cb({ timeRemaining: () => 12 }), 1));

  const run = (deadline) => {
    running = true;
    while (queue.length && deadline.timeRemaining() > 4) {
      const task = queue.shift();
      try { task.fn(); } catch (error) { console.warn('[AURA] Idle task failed', task.name, error); }
    }
    if (queue.length) requestIdle(run);
    else running = false;
  };

  const add = (name, fn) => {
    queue.push({ name, fn });
    if (!running) requestIdle(run);
  };

  const afterLoad = (name, fn) => {
    if (document.readyState === 'complete') add(name, fn);
    else window.addEventListener('load', () => add(name, fn), { once: true });
  };

  return { add, afterLoad, queue };
})();
